export default __webpack_public_path__ + "static/media/Left.5904269e.svg";